import { TbApi, TbWebhook } from "react-icons/tb"

import IconAccounts from "components/EvtKit/icons/sidebar/IconAccounts"
import IconEventTypes from "components/EvtKit/icons/sidebar/IconEventTypes"
import IconHome from "components/EvtKit/icons/sidebar/IconHome"
import IconInvoices from "components/EvtKit/icons/sidebar/IconInvoices"
import IconLogout from "components/EvtKit/icons/sidebar/IconLogout"
import IconProducts from "components/EvtKit/icons/sidebar/IconProducts"
import IconProfile from "components/EvtKit/icons/sidebar/IconProfile"
import IconPurchasePlans from "components/EvtKit/icons/sidebar/IconPurchasePlans"
import Heading from "components/Typography/Heading"
import { noop } from "utils/noop"
import IconMetrics from "components/EvtKit/icons/sidebar/IconMetrics"

export const sidebarOptions = [
  {
    icon: <IconHome />,
    title: (
      <Heading variant="h6" color="white">
        Home
      </Heading>
    ),
    mb: 0,
    onClick: noop,
    route: "/home",
    id: "home",
    type: ""
  },
  {
    icon: <IconProducts />,
    title: (
      <Heading variant="h6" color="white">
        Produtos
      </Heading>
    ),
    mb: 0,
    onClick: noop,
    route: "/products",
    id: "products",
    type: ""
  },
  {
    icon: <IconMetrics />,
    title: (
      <Heading variant="h6" color="white">
        Métricas
      </Heading>
    ),
    mb: 0,
    onClick: noop,
    route: "/metrics",
    id: "metrics",
    type: ""
  },
  {
    icon: <IconEventTypes />,
    title: (
      <Heading variant="h6" color="white">
        Tipos de Eventos
      </Heading>
    ),
    mb: 0,
    onClick: noop,
    route: "/event-types",
    id: "event-types",
    type: ""
  },
  {
    icon: <IconPurchasePlans />,
    title: (
      <Heading variant="h6" color="white">
        Planos
      </Heading>
    ),
    mb: 0,
    onClick: noop,
    route: "/purchase-plans",
    id: "purchase-plans",
    type: ""
  },
  {
    icon: <IconAccounts />,
    title: (
      <Heading variant="h6" color="white">
        Contas
      </Heading>
    ),
    mb: 0,
    onClick: noop,
    route: "/clients",
    id: "clients",
    type: ""
  },
  {
    icon: <IconInvoices />,
    title: (
      <Heading variant="h6" color="white">
        Faturas
      </Heading>
    ),
    mb: 0,
    onClick: noop,
    route: "/invoices",
    id: "invoices",
    type: ""
  },
  {
    icon: <TbApi color="white" />,
    title: (
      <Heading variant="h6" color="white">
        API Endpoints
      </Heading>
    ),
    mb: 0,
    onClick: noop,
    route: "/api-mappings",
    id: "api-mappings",
    type: ""
  },
  {
    icon: <TbWebhook color="white" />,
    title: (
      <Heading variant="h6" color="white">
        Webhooks
      </Heading>
    ),
    mb: 0,
    onClick: noop,
    route: "/webhooks",
    id: "webhooks",
    type: ""
  }
]

export const sidebarActionOptions = (userName: string, logoutAction: () => void) => {
  return [
    {
      icon: <IconProfile />,
      title: (
        <Heading variant="h6" color="white">
          {userName}
        </Heading>
      ),
      mb: 0,
      onClick: noop,
      route: "/profile",
      id: "profile",
      type: ""
    },
    {
      icon: <IconLogout />,
      title: (
        <Heading variant="h6" color="white">
          Sair
        </Heading>
      ),
      mb: 0,
      onClick: logoutAction,
      id: "logout",
      type: ""
    }
  ]
}
